import * as React from 'react';
import { defaultQuantumTheme } from '../theme/default-theme';
export var DEFAULT_COLOR_MODE = 'light';
export var QuantumContext = React.createContext({
    theme: defaultQuantumTheme[DEFAULT_COLOR_MODE],
    colorMode: DEFAULT_COLOR_MODE,
    setColorMode: function () {
        // ..
    },
});
export var useQuantumContext = function () { return React.useContext(QuantumContext); };
